<div class="fill-parent">
  <div class="report-head" *ngIf="!isout">
    <div class="report-back">
  <button class="main-btn empty-back-btn" (click)="navigateBack()"><img src="/assets/images/back.svg" />Chart Dashboard</button></div>
    <div class="report-title detail-page-title margin-l-l">
      eKitabu App Utilization
    </div>
    <div class="merlin-select">
      <mat-form-field class="grid-filter" floatLabel="never" appearance="legacy">
        <mat-select (selectionChange)="onSelectDate()" [(value)]="year">
          <mat-option></mat-option>
          <mat-option *ngFor="let year of years" [value]="year">
            {{year}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <!--<mat-datepicker-toggle  matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-input  [rangePicker]="picker">
        <input matStartDate [(ngModel)]="startDate" placeholder="Start date">
        <input matEndDate [(ngModel)]="endDate" placeholder="End date">
      </mat-date-input>
      <mat-date-range-picker (closed)="onSelectDate()" #picker></mat-date-range-picker>!-->
    </div>
  </div>
  <div *ngIf="heatmapMax + heatmapMin === 0">

    <label>No data in the selected period.</label>
  </div>

  <div class="chart-container" >


    <ngx-charts-heat-map [ngStyle]="heatmapMax + heatmapMin != 0 ? {'visibility': 'visible'} : {'visibility': 'hidden'}"
    [min]="0"
    [max]="heatmapMax"
    [view]="viewsize"
    [scheme]="colorScheme"
    [results]="calendarData"
    [animations]="true"
    [legend]="showLegend"
    [legendTitle]="legendTitle"
    [gradient]="gradient"
    [xAxis]="showXAxis"
    [yAxis]="showYAxis"
    [showXAxisLabel]="false"
    [showYAxisLabel]="false"
    [xAxisTickFormatting]="calendarAxisTickFormatting"
    [tooltipText]="calendarTooltipText"
    [innerPadding]="innerPadding"
    [tooltipDisabled]="tooltipDisabled"
    [trimXAxisTicks]="trimXAxisTicks"
    [trimYAxisTicks]="trimYAxisTicks"
    [rotateXAxisTicks]="rotateXAxisTicks"
    [maxXAxisTickLength]="maxXAxisTickLength"
    [maxYAxisTickLength]="maxYAxisTickLength">
  </ngx-charts-heat-map>

<div class="chart-description" *ngIf="!isout" [ngStyle]="heatmapMax + heatmapMin != 0 ? {'visibility': 'visible'} : {'visibility': 'hidden'}">
    Total number of events
</div>
</div>
</div>
